<template>
  <el-dropdown trigger="click" @command="handleCommand">
    <span :class="$style[`${iconSet.icon}`]"></span>
    <el-dropdown-menu
      slot="dropdown"
      :class="['dropDownMenu', iconSet.className]"
    >
      <el-dropdown-item v-if="showShare">
        <el-popover
          placement="right-start"
          trigger="hover"
          popper-class="shareTips"
          v-model="popoverVisible"
          :visible-arrow="false"
        >
          <div class="content" @click="popoverVisible = false">
            <div
              class="shareTipsItem"
              @click="$emit('share')"
              v-if="$modules.share"
            >
              {{ $t("265b2730bd") }}
            </div>
            <div
              class="shareTipsItem"
              @click="$emit('show-qrcode')"
              v-if="$modules.sendToPhone"
            >
              {{ $t("40ad48e2e6") }}
            </div>
          </div>
          <div slot="reference" class="shareItem" @click.stop>
            <span>{{ $t("265b2730bd") }}</span>
            <span class="right"></span>
          </div>
        </el-popover>
      </el-dropdown-item>
      <el-dropdown-item command="open" v-if="!isOhOsApp && userInfo && $modules.openByWPS">{{
        iconSet.opentxt
      }}</el-dropdown-item>
      <el-dropdown-item command="copyTo" v-if="userInfo && $modules.saveas">{{
        $t("de36f56297")
      }}</el-dropdown-item>
      <el-dropdown-item command="download" v-if="$modules.download">{{
        $t("88a5eec7a5")
      }}</el-dropdown-item>
      <el-dropdown-item
        command="home"
        v-if="iconSet.showback && $modules.toHome"
        >{{ $t("e42de3af08") }}</el-dropdown-item
      >
      <el-dropdown-item command="report" v-if="showReport">{{
        $t("bb898f8c35")
      }}</el-dropdown-item>
      <div :class="$style.divided"></div>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import i18n from '@/i18n'
import { mapState } from 'vuex'
import { download, downloadBySid } from '@/services/api'
import Emitter from 'element-ui/lib/mixins/emitter'
import getError from '@/utils/error.js'
import DialogReport from '@kso/ui/lib/DialogReport'
import DownloadCommand from '@/utils/command/download'
import { errorCodeMap } from '@/utils/errorcodes.js'
import { isOhOs, isWpsOfficeApp } from '@/utils/tools'
export default {
  props: {
    iconSet: {
      default: () => ({
        icon: 'trigger',
        opentxt: i18n.t('ff71e4f8a2'),
        showshare: false,
        showback: true,
        className: ''
      })
    }
  },
  data() {
    return {
      popoverVisible: false,
      // 鸿蒙系统在WPS端内无需展示打开WPS按钮
      isOhOsApp: isWpsOfficeApp && isOhOs
    }
  },
  computed: {
    ...mapState(['fileInfo', 'userInfo', 'currentTime']),
    showShare() {
      return (
        this.userInfo &&
        this.iconSet.showshare &&
        (this.$modules.share || this.$modules.sendToPhone)
      )
    },
    showReport() {
      const isCreator = this.userInfo.userid == this.fileInfo.creator.id
      const isShareFile = this.fileInfo.ftype === 'sharefile'
      const isSameCompany =
        this.fileInfo.creator.corpid === this.userInfo.companyid
      return (
        this.$modules.report && isSameCompany && (!isCreator || isShareFile)
      )
    }
  },
  mixins: [Emitter],
  methods: {
    getErrorMsg(e) {
      let code = e.code || e.result
      let msg = getError(e)
      let adminForbidCode = i18n.t('a670f3c26a')
      if (msg) {
        this.msg = msg
        return this.$message.error(msg)
      } else if (code === errorCodeMap.NOT_COMPANY_CHECK_FAILED) {
        this.$message.error(i18n.t('cd8cf2f471'))
      } else if (code === adminForbidCode) {
        this.$message.error(adminForbidCode)
      } else {
        this.$message.error(i18n.t('9cae53c65a'))
      }
    },
    async openReportDialog() {
      const cid = this.$route.params.sid || this.fileInfo.link_id
      console.log(DialogReport.option)
      await DialogReport.show({
        title: i18n.t('bb898f8c35'),
        cid,
        btnTxt: i18n.t('1ee5f66661')
      })
    },
    handleCommand(command) {
      command &&
        this.dispatch('APP', 'dwReporter', {
          page: 'preview',
          operation: command === 'download' ? 'download_left' : command,
          play_time: this.currentTime.toFixed(2)
        })
      switch (command) {
        case 'download':
          let downloadAdapter = null
          if (this.userInfo) {
            downloadAdapter = download(
              this.fileInfo.groupid,
              this.fileInfo.fileid
            )
          } else if (this.$route.params.sid) {
            downloadAdapter = downloadBySid(this.$route.params.sid)
          } else {
            downloadAdapter = download(
              this.fileInfo.groupid,
              this.fileInfo.fileid
            )
          }
          downloadAdapter
            .then((res) => {
              const command = new DownloadCommand(
                res.fileinfo.url,
                this.fileInfo
              )
              command.execute()
            })
            .catch(({ response }) => {
              let { result, code } = response.data
              this.getErrorMsg(result || code)
            })
          break
        case 'open':
          window.open(
            `ksoqing://type=open&fileid=${this.fileInfo.fileid}`,
            '_self',
            'height=1,width=1,top=0,left=0,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no'
          )
          break
        case 'home':
          window.location.href = 'https://kdocs.cn'
          break
        case 'feedback':
          break
        case 'copyTo':
          this.kdialog.show('copy', {
            id: [parseInt(this.fileInfo.fileid)],
            saveas: true
          })
          break
        case 'report':
          this.openReportDialog()
          break
      }
    }
  }
}
</script>
<style lang="scss" module>
$size: 30px;

.trigger {
  display: inline-block;
  width: $size;
  height: $size;
  background: url(./assets/dot.svg) no-repeat 50% #fff;
  background-size: 24px;
  border: 1px solid #e2e2e2;
  box-sizing: border-box;
  vertical-align: middle;
  outline: none;
}

.moreicon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url(./assets/more.svg);
}

.divided {
  height: 1px;
  background: #e3e3e3;
}

:global {
  body {
    .shareItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .right {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url(./assets/right.svg);
      }
    }
    .shareTips {
      border: none;
      padding: 4px;
      background: #fff;
      border-radius: 2px;
      min-width: 108px;
      box-shadow: 0px 2px 12px 0px rgba(56, 56, 56, 0.2);
      .content {
        background: #fff;
        cursor: pointer;
        .shareTipsItem {
          padding: 0 16px;
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          &:hover {
            background: rgba(25, 55, 88, 0.04);
          }
        }
      }
    }
    .dropDownMenu {
      padding: 0 4px;
      margin-top: 8px !important;
      border-radius: 2px;
      width: 108px;
      border: none;
      box-shadow: 0 2px 12px 0 rgba(56, 56, 56, 0.2);
      transition: none;

      .popper__arrow {
        display: none;
      }

      .el-dropdown-menu__item {
        padding: 0 0 0 10px;
        margin: 4px 0;
        overflow: hidden;
        font-size: 12px;
        color: #626b84;
        height: 30px;
        line-height: 30px;
      }

      .el-dropdown-menu__item:focus,
      .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: #f3f3f3;
        color: #626b84;
      }
    }
  }
}
</style>
